import Bb from '../../../config/backbone'
import dispatcher from '../../../dispatcher'

const Game = Bb.Model.extend({
    defaults: {
        date: '',
        players: [],
        winner: {}
    },
    initialize(){
        Bb.Model.prototype.initialize.apply(this, arguments)
        this.listenTo(this, 'change', ()=> {
            dispatcher.emit('playedGamesHistory:changed')
        })
    }
})

const PlayedGamesHistory = Bb.Collection.extend({
    model: Game,
    initialize(){
        Bb.Collection.prototype.initialize.apply(this, arguments)
        this.listenTo(this, 'remove add', ()=> {
            dispatcher.emit('playedGamesHistory:changed')
        })
    }
})

export default PlayedGamesHistory



// WEBPACK FOOTER //
// ./src/game/history/collection/PlayedGamesHistory.js